export const getRandomLightRgba = () => {
  const r = 180 + Math.floor(Math.random() * 56); // 200–255
  const g = 180 + Math.floor(Math.random() * 56);
  const b = 180 + Math.floor(Math.random() * 56);
  const a = 0.3 + Math.random() * 0.2; // 0.3–0.5
  return `rgba(${r}, ${g}, ${b}, ${a.toFixed(2)})`;
};
